import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { blogPosts } from '../data/blogPosts';
import Navbar from './Navbar';
import BlogPostHeader from './blog/BlogPostHeader';
import BlogContent from './blog/BlogContent';

const BlogPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { language } = useLanguage();

  // Get the post based on current language
  const post = blogPosts[language].find(p => p.id === id);

  // Scroll to top when component mounts and redirect if post not found
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // If post not found, redirect to home
    if (!post) {
      navigate('/');
    }
  }, [id, post, navigate]);

  // Show loading state while redirecting
  if (!post) {
    return null;
  }

  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar />
      <BlogPostHeader post={post} />
      <BlogContent content={post.content} />
    </div>
  );
};

export default BlogPost;
